import { jsx as _jsx } from "react/jsx-runtime";
import List from "components/Lists/List";
import DELETE_EMAILS_HEADINGS from "mutations/emails/deleteEmailsHeading";
import GET_EMAILS_HEADINGS from "queries/emails/getEmailsHeadings";
const HeadingsList = () => (_jsx(List, { deleteMutation: DELETE_EMAILS_HEADINGS, itemNamePlural: "headings", label: "Headings", listQuery: GET_EMAILS_HEADINGS, listQueryDataName: "getEmailsHeadings", pathPrefix: "/emails" }));
export default HeadingsList;
